import { SpecialtyCard } from "./specialty-card";

export const SpecialtyGroup = ({ group, specialties }) => {
    return (
        <div>
            <div className="mb-4 flex flex-wrap items-end gap-x-3">
                <h2 className="text-xl font-semibold">{group.categoryTitle}</h2>
                <p className="text-neutral-500">{group.categoryDescription}</p>
                <hr className="mt-auto mb-2 h-px flex-1 border-gray-200" />
            </div>
            <div className="grid grid-cols-12 gap-4">
                {specialties.map((specialty) => (
                    <div
                        key={specialty.id}
                        className="col-span-full md:col-span-4"
                    >
                        <SpecialtyCard specialty={specialty} />
                    </div>
                ))}
            </div>
        </div>
    );
};
